import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type CheersIconProps = CreateIconComponentProps;
export const CheersIcon: React.FC<CheersIconProps> = ({
  title = 'Cheers',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.75"
      d="m7.268 2.772 3.864 1.035s-.328 5.089-.846 7.02c-.518 1.932-3.674 2.122-3.674 2.122S3.985 11.16 4.49 9.275c.505-1.886 2.777-6.503 2.777-6.503Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.75"
      d="m6.612 12.949-1.294 4.83M6.991 19.262l-3.864-1.035"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.75"
      d="M6.88 4.221c.031.526.333 1.85 1.285 2.932.952 1.084 1.834 1.527 2.156 1.613"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.75"
      d="m13.966 6.294 3.864-1.035s2.26 4.57 2.777 6.502c.518 1.932-2.121 3.675-2.121 3.675s-3.169-.236-3.674-2.122c-.506-1.886-.846-7.02-.846-7.02Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.75"
      d="m18.486 15.436 1.294 4.829M21.971 20.713l-3.864 1.036"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.75"
      d="M14.354 7.743c.29.44 1.213 1.435 2.579 1.897 1.366.462 2.352.405 2.674.319"
    />
  </CreateIconComponent>
);
